import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Excel() {
  return <PlatformPage feature={platformFeatures['excel']!} />
}
